<div class="field-history-container">
  <div class="field-list-table-container">
    <list-table-without-filters-wrapper
      [columns]="tableColumns"
      [subtitle]="subtitle"
      [service]="historyService"
      [getAllMethod]="getAllMethod"
      [getTotalMethod]="getTotalMethod"
      [filtersForms]="filtersForms"
      [isLoading]="loading"
      [storageKey]="storageKey"
      [toggleFilter]="toggleFilter"
      [defaultParams]="defaultParams"
      [filtersParams]="filtersParams"
      [methodWithParams]="methodWithParams">
    </list-table-without-filters-wrapper>
  </div>

  <!-- Шаблоны для таблицы истории -->
  <ng-template #dateTemplate let-row>
    <span>{{ row.createAt ? (row.createAt | dateFormatLang: translate.currentLang:true) || '-' : '-' }}</span>
  </ng-template>

  <ng-template #changesTemplate let-row>
    <div class="changed-fields-list">
      @if (!row.oldModel && row.newModel) {
        <span class="change-badge created">{{ 'Created' | translate }}</span>
      } @else if (row.oldModel && !row.newModel) {
        <span class="change-badge deleted">{{ 'Deleted' | translate }}</span>
      } @else {
        @if (row.changedFieldsNames && row.changedFieldsNames.length > 0) {
          <div class="changed-fields-badges">
            @for (fieldName of row.changedFieldsNames; track fieldName) {
              <span class="changed-field-badge">
                {{ fieldName | translate }}
              </span>
            }
          </div>
        } @else {
          <span class="no-changes">-</span>
        }
      }
    </div>
  </ng-template>

  <ng-template #userTemplate let-row>
    <span>{{ row.versionUserName || '-' }}</span>
  </ng-template>

  <ng-template #actionOpenTemplate let-row>
    <button
      pButton
      type="button"
      icon="pi pi-eye"
      class="p-button-text p-button-sm p-button-rounded open-button"
      (click)="openHistoryVersionModal(row)"
      [title]="'Open version' | translate">
    </button>
  </ng-template>
</div>
